import script from "./UpgradeRequired.vue?vue&type=script&setup=true&lang=js"
export * from "./UpgradeRequired.vue?vue&type=script&setup=true&lang=js"

import "./UpgradeRequired.vue?vue&type=style&index=0&id=2e9baff0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e9baff0"]])

export default __exports__